export { default as Fingerprint } from './Fingerprint';
